import queryString from 'query-string';
import { findResolver } from './WidgetResolver';
import IFrameWidgetRenderer from '../IFrameWidgetRenderer';
import LegacyWidgetContainer from '../LegacyWidgetContainer';

const REGION_LIVE = 'live';
const REGION_BETA = 'beta';

const isSupportedContentType = (contentType) => {
    return (
        contentType &&
        (contentType.indexOf('application/javascript') !== -1 ||
            contentType.indexOf('text/javascript') !== -1)
    );
};

const addCacheBuster = (widgetUrl) => {
    const anchor = document.createElement('a');
    anchor.href = widgetUrl;

    const { search, hash, pathname } = anchor;
    let { origin } = anchor;

    if (!origin) {
        origin = `${anchor.protocol}//${anchor.host}/`;
    }

    const parsed = queryString.parse(search);
    const date = new Date();

    /* eslint-disable no-underscore-dangle */
    parsed.__cacheBuster = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;

    return `${origin}${pathname}?${queryString.stringify(parsed)}${hash}`;
};

const getWidgetComponent = (responseText, sourceUrl) => {
    let str = responseText;

    if (str) {
        if (str.indexOf('/*') === 0) {
            const endIndex = str.indexOf('*/');
            str = str.substring(endIndex + 2);
        }
        str = str.trim();
    }

    let defaultWidgetPublicPath = '';

    if (sourceUrl) {
        const parts = sourceUrl.split('/');
        parts.splice(-3);
        defaultWidgetPublicPath = `${parts.join('/')}/`;
    }
    const resolver = findResolver(str, defaultWidgetPublicPath);

    if (!resolver) {
        throw new Error('INVALID_LIBRARY_TARGET');
    }

    const component = resolver(str, defaultWidgetPublicPath);

    if (!component) {
        throw new Error('INVALID_LIBRARY_TARGET');
    }

    if (!component.default) {
        return { default: component };
    }

    return component;
};

const WidgetService = {
    async fetchWidgetComponent(sourceUrl, fiDomainInfo, isIFrame) {
        if (sourceUrl && isIFrame) {
            return Promise.resolve({
                default: IFrameWidgetRenderer,
            });
        }

        if (!sourceUrl) {
            return Promise.resolve({
                default: LegacyWidgetContainer,
            });
        }

        let widgetUrl = sourceUrl;

        if (
            sourceUrl.indexOf('/') === 0 &&
            fiDomainInfo &&
            fiDomainInfo.origin
        ) {
            widgetUrl = `${fiDomainInfo.origin}${sourceUrl}`;
        }

        const urlWithCacheBuster = addCacheBuster(widgetUrl);

        const response = await fetch(urlWithCacheBuster);
        const contentType = response.headers.get('content-type');

        if (!isSupportedContentType(contentType)) {
            throw new Error('INVALID_CONTENT_TYPE');
        }
        const responseText = await response.text();

        if (!responseText) {
            throw new Error('INVALID_WIDGET_RESPONSE');
        }

        return getWidgetComponent(responseText, sourceUrl);
    },

    getFIDomainInfo: (baseURLParam) => {
        let baseURL = baseURLParam;

        if (!baseURL) {
            baseURL = window.location.href;
        }

        if (!baseURL) {
            return {};
        }

        const a = document.createElement('a');
        a.href = baseURL;

        const { pathname } = a;
        let { origin } = a;

        if (!origin) {
            origin = `${a.protocol}//${a.host}`;
        }

        let region = '';

        if (pathname) {
            if (pathname.indexOf(`/${REGION_LIVE}`) !== -1) {
                region = REGION_LIVE;
            } else if (pathname.indexOf(`/${REGION_BETA}`) !== -1) {
                region = REGION_BETA;
            }
        }
        const fiDomainInfo = {};
        fiDomainInfo.origin = origin;
        fiDomainInfo.region = region;

        return fiDomainInfo;
    },
};
export default WidgetService;
